'use strict';

/**
 * Initialize campaign form
 */

function initializeFormEvent() {
	if ($(".campaign-form").length > 0) {
		$('.campaign-form .register').on('click', function(e) {
			e.preventDefault();
			if($('.campaign-form').valid()) {
				let dataToPost = 'dwfrm_campaign_register=dwfrm_campaign_register'+ '&' + $('.campaign-form').serialize();
				
				$.ajax({
					type: 'POST',
					url: $('.campaign-form').attr('action'),
					async: false,
					data: dataToPost,
					success: function (response) {
						location.reload();
						$(window).scrollTop(0);
					}			
				});
			}
		
		});
	}
}

export default {
	init: function () {
		initializeFormEvent();
	}
};